import { Box, Card, Typography, Alert } from '@mui/material';
import { httpRequest } from 'src/services/httpRequest';
import FormikForm from 'src/ui-component/FormikFormLibrary';
import toast from 'react-hot-toast';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { handleError } from 'src/redux-store/slices/errorSlice';
import { useDispatch } from 'react-redux';
import LoadingOverlay from 'src/components/common/LoadingOverlay';

interface Field {
  fieldName: string;
  fieldLabel: string;
  fieldType:
    | 'email'
    | 'password'
    | 'text'
    | 'number'
    | 'autocomplete'
    | 'note'
    | 'radio'
    | 'date'
    | 'select'
    | 'file';
  required: boolean;
  initialValue: string;
  heading: string;
  options: any;
  disabled: boolean;
  dependency: any;
}

const TownshipUserAccess: React.FC = () => {
  const dispatch = useDispatch();
  const { townshipId } = useParams<{ townshipId: string }>();
  const Navigate = useNavigate();
  const [permits, setPermits] = useState([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [approver, setApprover] = useState([]);
  const [ischeck, setIscheck] = useState('');
  const [CloneData, setCloneData] = useState([]);
  const [initialValue, setInitialValue] = useState({
    selectpermit: '',
    approver: [],
    ccemail: []
  });

  //Filter options
  function filterOptions(data: any, itemKey: string) {
    const allPermitOption = data?.map((item) => item[itemKey]);
    return allPermitOption;
  }

  //Get data from API
  const getData = async (url: string, setState: any, keyFor: string) => {
    try {
      const response = await httpRequest('GET', url);
      const data = await response?.data;
      if (response?.status === 'success') {
        if (keyFor === 'approver') {
          const aapproverData = data[0]?.Users?.filter(
            (item) => item.UserRoleID === 2
          );

          setInitialValue({
            selectpermit: ischeck,
            approver: aapproverData.map((item) => item.FullName),
            ccemail: data[0]?.CCEmail === null ? [] : data[0]?.CCEmail
          });
          setState(data[0].Users);
        } else {
          setState(data);
        }
      } else if (response.type === 'NETWORK_ERROR') {
      } else {
        toast.error(response?.message);
        dispatch(handleError(response?.message));
      }
    } catch (error) {
      toast.error('An error occurred while fetching permits');
      console.error('Error:', error);
    }
  };

  //Method to get Users By Township_Permits
  function handleDependency(val: string) {
    const permitId = permits.find((element) => {
      return val === element.PermitName;
    });
    getData(
      `/configuration/getUsersByTownship_Permits?TownshipID=${townshipId}&PermitID=${permitId.PermitID}`,
      setApprover,
      'approver'
    );

    setIscheck(val);
  }

  //Form fields using formik
  const allFields: Field[] = [
    {
      fieldName: 'selectpermit',
      fieldLabel: 'Select Application ',
      fieldType: 'select',
      options: filterOptions(permits, 'PermitName'),
      required: true,
      initialValue: ischeck,
      heading: '',
      disabled: false,
      dependency: handleDependency
    }
  ];

  //UseEffect to get permits and approver
  useEffect(() => {
    if (!permits.length) {
      getData(
        `/configuration/getPermitsByTownshipID?TownshipID=${townshipId}`,
        setPermits,
        ''
      );
    }

    setCloneData([
      {
        fieldName: 'approver',
        fieldLabel: 'Select Approver ',
        fieldType: 'multiselect',
        required: true,
        options: filterOptions(approver, 'FullName'),
        initialValue: initialValue.approver,
        heading: '',
        disabled: false,
        dependency: null,
        multiSelect: true
      },
      {
        fieldName: 'ccemail',
        fieldLabel: 'CC Email ',
        fieldType: 'tagInput',
        required: true,
        options: false,
        initialValue: initialValue.ccemail,
        heading: '',
        disabled: false,
        dependency: null,
        multipleTagInput: true
      }
    ]);
  }, [ischeck, initialValue, approver]);

  //Method to submit the form
  async function handleSubmit(value: any) {
    setLoading(true);
    const userId = [];
    approver.forEach((element) => {
      if (value.approver.includes(element.FullName)) {
        userId.push(element.UserID);
      }
    });

    const permitId = permits.find((element) => {
      return value.selectpermit === element.PermitName;
    });

    const body = {
      UserID: userId,
      PermitID: permitId.PermitID,
      CCEmail: value.ccemail
    };

    const response = await httpRequest(
      'POST',
      `/configuration/promoteToManager`,
      body
    );
    if (response?.status === 'success') {
      toast.success('The permit approval has been successfully submitted.');
      setLoading(false);
    } else {
      toast.error(response?.message);
      setLoading(false);
      dispatch(handleError(response?.message));
    }
  }

  //Method to cancel the form
  function handleCancel() {
    Navigate(`/dashboard/${townshipId}`);
  }

  return (
    <Card>
      {loading && <LoadingOverlay />}
      <Box m={3}>
        <Typography variant="h4" mb={3}>
          <Alert severity="info">
            This user has the ability to manage vendor applications and permit
            requests within the township.
          </Alert>
        </Typography>
        <FormikForm
          allFields={ischeck ? allFields.concat(CloneData) : allFields}
          buttonTitle={['Cancel', 'Save']}
          fullScreen={false}
          isEditModel={false}
          content={false}
          formMethod={handleSubmit}
          heading={'Road Permit'}
          handleOtherButton={handleCancel}
        />
      </Box>
    </Card>
  );
};

export default TownshipUserAccess;
